import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { desktop_small_l, mobile_xl, mobile_xs } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../global/commonStyle';

const Group = styled.div`
  max-width: 1022px;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const TopBlock = styled.div`
  background-color: var(--background-secondary);
`;

const HeaderBlock = styled.div`
  ${FlexBetween}
  padding-block: var(--space-10);
  position: sticky;
  z-index: var(--z-index-header);
  top: 0px;
  background-color: var(--background-secondary);
`;

const Heading = styled.div`
  ${AlignCenter}
  padding-block: var(--space-3);
  gap: var(--space-8);
`;

const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    width: 24px;
    height: 24px;
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const TitleWrap = styled.h2`
  width: 100%;
  max-width: 510px;
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-primary);
  margin: var(--space-0);
`;

const OptionMenu = styled.div`
  position: relative;
  .more-icon:hover {
    background-color: var(--background-muted);
  }
  ${mobile_xl(css`
    .more-icon:hover {
      background-color: unset;
    }
    /* Active state when dropdown is open */
    &.active-state {
      background-color: var(--neutral-secondary);
    }
  `)}
`;

const UserDetails = styled.div`
  width: 100%;
  max-width: 535px;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-height: 42px;
  justify-content: center;
`;

const Username = styled.h5`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const UserDescription = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const UserMail = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  ${mobile_xl(css`
    padding-left: var(--space-12);
    margin-right: var(--space-13);
  `)}
`;

const ProfileIcon = styled.div`
  padding-inline: var(--space-4);
  ${FlexCenter}
`;
const Userprofile = styled.div`
  padding-left: var(--space-12);
  ${AlignCenter}
  gap: var(--space-12);
  width: 100%;
  min-width: 280px;
  ${mobile_xl(css`
    min-width: 230px;
    max-width: 238px;
  `)}
`;
const Profile = styled.div`
  width: 28px;
  height: 28px;
  img {
    border-radius: var(--border-radius-full);
    object-fit: cover;
  }
`;

const HeaderLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;
const PaginationSection = styled.div`
  ${FlexCenter}
  gap: var(--space-32);
  padding-block: var(--space-40);
  background-color: var(--background-secondary);
  ${mobile_xl(css`
    padding-block: var(--space-20) var(--space-96);
    justify-content: space-between;
    gap: var(--space-20);
  `)}
  ${mobile_xs(css`
    flex-direction: column;
  `)}
`;
const LeftDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const RightDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const Text = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;
const ArrowBtn = styled.div`
  width: 66px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-full);
  display: flex;
  .left-arrow-icon {
    box-shadow: none;
    border-radius: var(--border-radius-full) var(--border-radius-0) var(--border-radius-0) var(--border-radius-full);
    border-right: 0.5px solid var(--border-primary);
  }
  .right-arrow-icon {
    box-shadow: none;
    border-radius: var(--border-radius-0) var(--border-radius-full) var(--border-radius-full) var(--border-radius-0);
  }
  ${mobile_xl(css`
    width: auto;
    background: unset;
    border: unset;
    gap: var(--space-4);
    .left-arrow-icon {
      border-radius: var(--border-radius-8);
      border-right: none;
    }
    .right-arrow-icon {
      border-radius: var(--border-radius-8);
    }
  `)}
`;

const ShowRow = styled.div`
  border-radius: var(--border-radius-full);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-7) var(--space-7) var(--space-7) var(--space-11);
  ${AlignCenter}
  gap: var(--space-18);
  cursor: pointer;
  ${mobile_xl(css`
    padding: unset;
    border: unset;
    background-color: unset;
    gap: var(--space-4);
  `)}
`;
const RowText = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;
const Downarrow = styled.div`
  display: flex;
  .arrow-open {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    svg {
      width: 18px;
      height: 18px;
    }
  `)}
`;

const TableWrapper = styled.div`
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  ${HideScrollbar}
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;

const TableHead = styled.thead`
  background-color: var(--background-tertiary);
  tr {
    display: flex;
    gap: var(--space-40);
    align-items: center;
    ${mobile_xl(css`
      gap: var(--space-18);
    `)}
  }
`;

const TableHeader = styled.th`
  text-align: start;
  padding: var(--space-12) var(--space-0);
  &:first-child {
    width: 100%;
    ${mobile_xl(css`
      max-width: 250px;
    `)}
  }
  p {
    padding-left: var(--space-12);
    margin: var(--space-0);
    text-transform: uppercase;
    box-shadow: var(--left-border);
  }

  &:nth-child(2) {
    min-width: 210px;
  }
  &:nth-last-child(2) {
    min-width: 153px;
  }

  &:last-child {
    min-width: 36px;
    ${desktop_small_l(css`
      min-width: 48px;
      position: sticky;
      right: 0;
      background-color: var(--background-tertiary);
      ${AlignCenter}
      box-shadow: var(--shadow-card);
    `)}
    ${mobile_xl(css`
      min-width: 50px;
    `)}
  }
`;

const TableRow = styled.tr`
  display: flex;
  align-items: center;
  gap: var(--space-40);
  justify-content: space-between;
  cursor: pointer;
  border-top: 0.5px solid var(--border-primary);
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    gap: var(--space-18);
  `)}
`;

const TableData = styled.td`
  padding: var(--space-7) var(--space-0);
  &:first-child {
    width: 100%;
    ${mobile_xl(css`
      max-width: 250px;
    `)}
  }
  &:not(:first-child) {
    p {
      padding-left: var(--space-12);
      margin: var(--space-0);
    }
  }
  &:nth-child(2) {
    min-width: 210px;
  }
  &:nth-last-child(2) {
    min-width: 153px;
  }
  &:last-child {
    padding-right: var(--space-12);
    ${desktop_small_l(css`
      position: sticky;
      right: 0;
      padding: var(--space-16) var(--space-12);
      background-color: var(--background-primary);
      ${AlignCenter}
      box-shadow: var(--shadow-card);
    `)}
    ${mobile_xl(css`
      padding-block: var(--space-18);
    `)}
  }
  /* dropdown button active state design */
  .active {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-4);
  }
`;

export {
  Group,
  TopBlock,
  HeaderBlock,
  Heading,
  Icon,
  Title,
  TitleWrap,
  UserDetails,
  Username,
  UserDescription,
  UserMail,
  ProfileIcon,
  Userprofile,
  Profile,
  OptionMenu,
  HeaderLeft,
  PaginationSection,
  RightDiv,
  LeftDiv,
  Text,
  ArrowBtn,
  ShowRow,
  RowText,
  Downarrow,
  TableWrapper,
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableData
};
